import React from 'react';
import { Eye, Edit, Trash2 } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { useNavigate } from 'react-router-dom';
export function EmailDetails() {
  const navigate = useNavigate();
  const emails = [{
    id: 1,
    subject: 'Welcome to Desert Sage',
    body: 'Thank you for registering...',
    created: '2023-01-01',
    status: 'Active'
  }, {
    id: 2,
    subject: 'Course Completion',
    body: 'Congratulations on completing...',
    created: '2023-01-01',
    status: 'Active'
  }, {
    id: 3,
    subject: 'Password Reset',
    body: 'Click here to reset...',
    created: '2023-01-01',
    status: 'Inactive'
  }];
  return <div className="space-y-4" data-id="element-1024" data-mp="1x08rcuedyymt">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-1025" data-mp="1wwupdn9mwrfw">Email Details</h1>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1026" data-mp="1rzbaqm90ycnf">
        <div className="overflow-x-auto" data-id="element-1027" data-mp="1n0huim2cs7jk">
          <table className="w-full text-sm text-left" data-id="element-1028" data-mp="1n1jh9nsqeih4">
            <thead className="bg-slate-800 text-white font-medium" data-id="element-1029" data-mp="1ldbxw041eayh">
              <tr data-id="element-1030" data-mp="1q4aj9e3vtz8l">
                <th className="px-3 py-3 border-r border-slate-700 text-center w-12" data-id="element-1031" data-mp="1q4u1yx1cwrno">
                  Id
                </th>
                <th className="px-3 py-3 border-r border-slate-700 w-40" data-id="element-1032" data-mp="1ce704w0aulnd">
                  Subject
                </th>
                <th className="px-3 py-3 border-r border-slate-700" data-id="element-1033" data-mp="1hc8j7gxq6kyu">Body</th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-36" data-id="element-1034" data-mp="252w4r50kd93v">
                  Created
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-16" data-id="element-1035" data-mp="29126fymjoyhx">
                  Status
                </th>
                <th className="px-3 py-3 text-center w-32" data-id="element-1036" data-mp="201ypb06xut62">
                  <div data-id="element-1037" data-mp="204kwuzttx8oa">Actions</div>
                  <div className="text-xs font-normal text-slate-400 mt-1" data-id="element-1038" data-mp="jnp0y62p54f8">
                    View | Edit | Delete
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-1039" data-mp="4kynkvg0samn">
              {emails.map(email => <tr key={email.id} className="hover:bg-slate-50" data-id="element-1040" data-mp="j3e33nxqqxs">
                  <td className="px-3 py-2.5 border-r border-slate-200 text-center align-top" data-id="element-1041" data-mp="lpu7row6erm">
                    {email.id}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 font-medium align-top" data-id="element-1042" data-mp="3mzzgnv99hcpr">
                    {email.subject}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 text-slate-600 align-top max-w-sm" data-id="element-1043" data-mp="3hxqoh147qeop">
                    <p className="line-clamp-3 text-xs" data-id="element-1044" data-mp="38zf0z7yn7x0h">{email.body}</p>
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 text-center align-top" data-id="element-1045" data-mp="3919kqiy6hj2z">
                    {email.created}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 text-center align-top" data-id="element-1046" data-mp="176qu8omsirfy">
                    <input type="checkbox" defaultChecked={email.status === 'Active'} className="rounded border-slate-300" data-id="element-1047" data-mp="12a0btunijjrd" />
                  </td>
                  <td className="px-3 py-2.5 text-center align-top" data-id="element-1048" data-mp="1ephyevqnp1ky">
                    <div className="flex items-center justify-center gap-2" data-id="element-1049" data-mp="1jjm4lcs3l5kz">
                      <button title="View" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/email-details/view/${email.id}`)} data-id="element-1050" data-mp="1ohno1ytfr6wz">
                        <Eye className="h-4 w-4" data-id="element-1051" data-mp="10rjvcmhscrkr" />
                      </button>
                      <button title="Edit" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/email-details/edit/${email.id}`)} data-id="element-1052" data-mp="14t52rsbjwdnk">
                        <Edit className="h-4 w-4" data-id="element-1053" data-mp="2eqv4q5xx0uom" />
                      </button>
                      <button title="Delete" className="p-1 text-slate-500 hover:text-red-600" data-id="element-1054" data-mp="29sbj66n8hkws">
                        <Trash2 className="h-4 w-4" data-id="element-1055" data-mp="2oqvry2ywnuy3" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}